export function GetMockApplicantList() {
  return [
    {
      id: 1,
      jmCaseId: 1,
      applicantName: "Lindsay Davey",
      applicantEmail: "lindsaycrampton@yahoo.co.uk",
      applicantPhone1: "07769661865",
      applicantPhone2: null,
      applicantAddress: "Colwyn House",
      applicantTown: "Colchester",
      applicantCounty: "Essex",
      applicantPostcode: "CO3 3LD",
      employmentStatusId: 36,
      otherPropertyOwned: 0,
      willPropBeSold: 0,
    },
    {
      id: 2,
      jmCaseId: 1,
      applicantName: null,
      applicantEmail: null,
      applicantPhone1: null,
      applicantPhone2: null,
      applicantAddress: null,
      applicantTown: null,
      applicantCounty: null,
      applicantPostcode: null,
      employmentStatusId: null,
      otherPropertyOwned: 0,
      willPropBeSold: 0,
    },
  ];
}
